import { assignIfExists } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { findQueryClause, findQueryProfile } from '../../state/shared';

const fetchClausesCountsState = (draft, action) => {
  const { profile } = findQueryProfile(draft.cohorts, action);
  assignIfExists(profile, { readStatus: states.PENDING, readErrors: [] });
};

export const fetchClauseCountsState = (draft, action) => {
  const { clause } = findQueryClause(draft.cohorts, action);
  if (clause) {
    assignIfExists(clause.profile, { readStatus: states.PENDING, readErrors: [] });
  }
};

export default fetchClausesCountsState;
